import Enum from '@/utils/Enum';

const USER_ROLES_ENUM = {
	READER: new Enum(0, 'reader')
};

export default USER_ROLES_ENUM;
